module ProcessEditor {
    interface IHttpTrigger {
        routeTemplate: string;
        allowedSchemes: string;
        auth: string;
        corsEnabled: boolean;
        allowedOrigins: string;
    }

    export function validateHttpAuthDirective(): ng.IDirective {
        return {
            restrict: "EA",
            require: 'ngModel',
            link: (scope: HttpTriggerScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController) => {
                ctrl.$validators["auth"] = function(modelValue, viewValue) {
                    if (viewValue !== "None" && scope.ctrl.config.allowedSchemes !== "HTTPS") {
                        return false;
                    }
                    return true;
                }

            }
        }
    }

    app.directive('frendsValidateHttpAuth', [validateHttpAuthDirective]);

    interface HttpTriggerScope extends ng.IScope {
        ctrl: HttpTriggerController;
    }

    export class HttpTriggerController {
        public config: IHttpTrigger;

        constructor() {
            if (this.config.routeTemplate == null) {
                this.config = {
                    routeTemplate: "",
                    allowedSchemes: "HTTPS",
                    auth: "None",
                    corsEnabled: false,
                    allowedOrigins: ""
                }
            }
            if (this.config.allowedSchemes == null) {
                this.config.allowedSchemes = "HTTPS";
            }
            if (this.config.auth == null) {
                this.config.auth = "None";
            }
        }
    }

    app.controller("HttpTriggerController", [HttpTriggerController]);


    export function httpTriggerDirective(): ng.IDirective {
        return {
            restrict: "EA",
            templateUrl: "httpTriggerEditor.htm",
            controller: "HttpTriggerController",
            controllerAs: "ctrl",
            bindToController: true,
            scope: {
                config: "="
            }
        }
    }
    app.directive("frendsHttpTrigger", [httpTriggerDirective]);



}